import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Logo from "../Utils/assets/img/pugcrm_logo.png";
import { Container } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import useApi from "../Utils/hooks/apihook";
import { baseURL } from './../Utils/constants/constant';


const schema = z
    .object({
        password: z.string().min(6, "Password must be at least 6 characters"),
        confirmPassword: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: "Passwords do not match",
        path: ["confirmPassword"],
    });

export const CreatePassword = () => {
    const { org_code, token, user_id } = useParams();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);


    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(schema),
    });

    const onSuccess = (data) => {
        toast.success("Password created successfully!");
        navigate("/login");
    };

    const onError = (data) => {
        toast.error(data.message || "Link expired or something went wrong");
        navigate("/error", { state: { message: data.message } });
    };

    const { triggerPost, loading } = useApi(
        `${baseURL}auth/register/createPassword/${org_code}/${token}/${user_id}`,
        null,
        onError,
        onSuccess,
    );

    const onSubmit = (data) => {
        triggerPost({
            password: data.password,
            conf_password: data.confirmPassword,
        });
        reset();
    };

    return (
        <Container fluid className="min-vh-100 bg-light p-0 d-flex align-items-center justify-content-center" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <div className="w-100" style={{ maxWidth: "500px" }}>
                <div className="bg-white rounded-3 shadow-sm p-4 mx-3" style={{ border: "1px solid #e0e0e0" }}>
                    <div className="text-center mb-4">
                        <img
                            src={Logo}
                            alt="Logo"
                            className="img-fluid mb-3"
                            style={{ maxWidth: "170px" }}
                        />
                        <h2>Create Password</h2>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-3 position-relative">
                            <label className="form-label">Password</label>
                            <input
                                type={showPassword ? "text" : "password"}
                                className={`form-control `}
                                {...register("password")}
                            />
                            <span
                                onClick={() => setShowPassword((prev) => !prev)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "38px",
                                    zIndex: 2,
                                    padding: "2px",
                                    cursor: "pointer",
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            {errors.password && (
                                <p className="text-danger" style={{ fontSize: "14px", marginTop: '4px' }}>{errors.password.message}</p>
                            )}
                        </div>

                        <div className="mb-3 position-relative">
                            <label className="form-label">Confirm Password</label>
                            <input
                                type={showConfirm ? "text" : "password"}
                                className={`form-control `}
                                {...register("confirmPassword")}
                            />
                            <span
                                onClick={() => setShowConfirm((prev) => !prev)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "38px",
                                    zIndex: 2,
                                    padding: "2px",
                                    cursor: "pointer",
                                }}
                            >
                                {showConfirm ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            {errors.confirmPassword && (
                                <p className="text-danger" style={{ fontSize: '12px', marginTop: '4px' }}>
                                    {errors.confirmPassword.message}
                                </p>
                            )}
                        </div>

                        <div className="d-flex w-100 justify-content-center">
                            <button style={{ backgroundColor: "#7a3a5e", color: 'white', border: 0 }} type="submit" className="w-50 py-2 fw-bold rounded-2" disabled={loading}>
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Container>
    )
}